import { ADD_CONFORM } from 'app/actions/eljur/conforms';

const defaultState = {
};

const conforms = (state = defaultState, action) => {
  switch (action.type) {

    case ADD_CONFORM: {
      return { ...state, ...action.payload };
    }

    default:
  }
  return state;
};

export default conforms;
